import React from 'react'
import CloseIcon from '@mui/icons-material/Close'

const IconButtonClose = ({
    onClick,
    icon,
    fontSize,
    top
}) => {
    const iconObj = icon || <CloseIcon fontSize={fontSize} />

    return (
        <button
            type="button"
            className="iconButtonClose"
            style={{
                top: top || undefined
            }}
            onClick={onClick}
            aria-label="Закрыть"
        >
            <span className="iconButtonClose__iconContainer">
                {iconObj}
            </span>
        </button>
    )
}

export default IconButtonClose